<script setup>
// BonBoZ: popup "Trang mất kết nối" (chép Pancake). Mở từ Gộp trang, chọn một
// trang ở Bảng điều khiển (gọi open), hoặc tự mở khi đang xem hội thoại mà
// một trang trong phạm vi vừa mất kết nối (prop ngheRealtime).
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useMapGetter } from 'dashboard/composables/store';
import { useEmitter } from 'dashboard/composables/emitter';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';
import {
  SU_KIEN_MAT_KET_NOI,
  trangMatKetNoi,
  idConKetNoi,
  choDangNhapLai,
} from 'dashboard/helper/trangMatKetNoi';
import PageCard from './PageCard.vue';

const props = defineProps({
  ngheRealtime: { type: Boolean, default: false },
});

// tiepTuc(ids): lựa chọn đã bỏ trang mất kết nối, chắc chắn không rỗng.
const emit = defineEmits(['tiepTuc']);

const { t } = useI18n();
const router = useRouter();
const { isAdmin } = useAdmin();
const accountId = useMapGetter('getCurrentAccountId');
const inboxes = useMapGetter('inboxes/getInboxes');
const { selectedInboxIds, setSelectedInboxes } = useSelectedPages();

const dialogRef = ref(null);
const trang = ref([]);
const conLai = ref([]);
const dangXem = ref(false);

const open = opts => {
  trang.value = opts.trang;
  conLai.value = opts.conLai ?? [];
  dangXem.value = !!opts.dangXem;
  dialogRef.value.open();
};

// Dang xem ma trang rot: dong popup kieu nao (Quay lai, X, Esc, bam ra ngoai)
// cung roi han trang do ve Bang dieu khien — o lai cung khong gui nhan duoc tin
// moi. Co nay de cac nut TU DI CHO KHAC (Bo qua, Dang nhap lai) khong bi day ve.
const tuDi = ref(false);

const close = () => dialogRef.value.close();

const onDong = () => {
  const day = dangXem.value && !tuDi.value;
  tuDi.value = false;
  dangXem.value = false;
  if (day) {
    router.push({
      name: 'bonboz_main_page',
      params: { accountId: accountId.value },
    });
  }
};

const tiepTuc = () => {
  tuDi.value = true;
  // Đang xem: tự thu hẹp phạm vi; còn lại người gọi tự áp lựa chọn.
  if (dangXem.value) setSelectedInboxes(conLai.value);
  else emit('tiepTuc', conLai.value);
  close();
};

const dangNhapLai = inbox => {
  const cho = choDangNhapLai(inbox);
  if (cho.url) window.open(cho.url, '_blank', 'noopener');
  else {
    tuDi.value = true;
    router.push({
      ...cho.route,
      params: { ...cho.route.params, accountId: accountId.value },
    });
    close();
  }
};

useEmitter(SU_KIEN_MAT_KET_NOI, inbox => {
  if (!props.ngheRealtime) return;
  const ids = selectedInboxIds.value;
  const mat = trangMatKetNoi(inboxes.value, ids);
  if (!mat.some(i => i.id === inbox.id)) return;
  open({ trang: mat, conLai: idConKetNoi(inboxes.value, ids), dangXem: true });
});

defineExpose({ open });
</script>

<template>
  <Dialog ref="dialogRef" width="xl" overflow-y-auto @close="onDong">
    <div class="flex flex-col items-center gap-2 text-center">
      <span
        class="flex items-center justify-center rounded-full size-12 bg-n-ruby-3 text-n-ruby-11"
      >
        <span class="i-lucide-x size-6" />
      </span>
      <h3 class="text-base font-semibold text-n-slate-12">
        {{
          dangXem
            ? t('BONBOZ.MAT_KET_NOI.TIEU_DE_DANG_XEM')
            : t('BONBOZ.MAT_KET_NOI.TIEU_DE')
        }}
      </h3>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('BONBOZ.MAT_KET_NOI.MO_TA') }}
      </p>
    </div>

    <!-- Quản trị bấm thẻ để mở đúng chỗ đăng nhập lại của trang đó. -->
    <div class="flex flex-col gap-2 overflow-y-auto max-h-80">
      <PageCard
        v-for="inbox in trang"
        :key="inbox.id"
        :inbox="inbox"
        :readonly="!isAdmin"
        @click="dangNhapLai"
      />
    </div>
    <p v-if="!isAdmin" class="mb-0 text-sm text-center text-n-amber-11">
      {{ t('BONBOZ.MAT_KET_NOI.BAO_QUAN_TRI') }}
    </p>

    <template #footer>
      <div class="flex flex-wrap items-center gap-3">
        <Button
          type="button"
          variant="faded"
          color="slate"
          :label="t('BONBOZ.MAT_KET_NOI.QUAY_LAI')"
          @click="close"
        />
        <div class="flex items-center gap-3 ms-auto">
          <!-- Ẩn khi bỏ xong không còn trang: mảng rỗng nghĩa là "tất cả". -->
          <Button
            v-if="conLai.length"
            type="button"
            variant="link"
            color="blue"
            :label="t('BONBOZ.MAT_KET_NOI.BO_QUA')"
            @click="tiepTuc"
          />
          <Button
            v-if="isAdmin"
            type="button"
            color="blue"
            :label="t('BONBOZ.MAT_KET_NOI.DANG_NHAP_LAI')"
            @click="dangNhapLai(trang[0])"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>
